import { html, View } from 'rune-ts';
import { ProductTimeHelper } from '@services/MarppleShop/renderApp/components/cells/ProductCard/utils/ProductTimeHelper';
import klass from './NessBadgeView.module.scss';

export type TNessBadgeViewProps =
  | { type: 'Custom' }
  | { type: 'Special_offer' }
  | {
      type: 'Rank';
      rank: number;
    }
  | {
      type: 'Stock_left';
      availableStock: number;

      // 낮을수록 우선 노출
      priority: number;
    }
  | {
      type: 'Time_left';
      endDate: Date;

      // 낮을수록 우선 노출
      priority: number;
    }
  | {
      type: 'Upcoming';
      stratDate: Date;
    }
  | {
      type: 'Sale';
      discountPercentage: number;
    }
  | {
      type: 'New';
      publicAt: Date;
    };

/**
 * @style legacy 라서 클래스명이 문자열로 되어 있어요
 * /modules/Ness/App/ProductBadge/components/item-ness-badge-color.styl
 */
export class NessBadgeView extends View<TNessBadgeViewProps> {
  protected override template() {
    if (this.data.type === 'Custom') {
      return html`<div class="${klass.ness_badge} app-product-item__badge" data-type="custom">
        ${ET('ness::product_badge::custom', { lng: 'en' })}
      </div>`;
    } else if (this.data.type === 'Rank') {
      return html`<div class="${klass.ness_badge} app-product-item__badge" data-type="ranking">
        ${this.data.rank.toString()}
      </div>`;
    } else if (this.data.type === 'Special_offer') {
      return html`<div class="${klass.ness_badge} app-product-item__badge" data-type="limited">
        ${ET('ness::product_badge::special', { lng: 'en' })}
        ${ET('ness::product_badge::offer', { lng: 'en' })}
      </div>`;
    } else if (this.data.type === 'Stock_left') {
      return html`<div class="${klass.ness_badge} app-product-item__badge" data-type="quantity_limited">
        ${ET('ness::product_badge::quantity_limited', {
          count: this.data.availableStock,
          lng: 'en',
        })}
      </div>`;
    } else if (this.data.type === 'Time_left') {
      const timeLeft = ProductTimeHelper.diffDate(this.data.endDate, new Date());
      if (timeLeft.day) {
        return html`<div class="${klass.ness_badge} app-product-item__badge" data-type="period_limited">
          ${ET('ness::product_badge::day', { count: timeLeft.day, lng: 'en' })}
          ${ET('ness::product_badge::left', { lng: 'en' })}
        </div>`;
      } else if (timeLeft.hour) {
        return html`<div class="${klass.ness_badge} app-product-item__badge" data-type="period_limited">
          ${ET('ness::product_badge::hour', { count: timeLeft.hour, lng: 'en' })}
          ${ET('ness::product_badge::left', { lng: 'en' })}
        </div>`;
      } else if (timeLeft.minute) {
        return html`<div class="${klass.ness_badge} app-product-item__badge" data-type="period_limited">
          ${ET('ness::product_badge::minute', { count: timeLeft.minute, lng: 'en' })}
          ${ET('ness::product_badge::left', { lng: 'en' })}
        </div>`;
      } else {
        return html`<div></div>`;
      }
    } else if (this.data.type === 'Sale') {
      return html`<div class="${klass.ness_badge} app-product-item__badge" data-type="sale">
        ${ET('ness::product_badge::sale', { lng: 'en' })}
      </div>`;
    } else if (this.data.type === 'New') {
      return html`<div class="${klass.ness_badge} app-product-item__badge" data-type="new">
        ${ET('ness::product_badge::new', { lng: 'en' })}
      </div>`;
    }

    throw new Error(`Unsupported badge type`);
  }
}
